import { render, staticRenderFns } from "./newTree.vue?vue&type=template&id=57c3d735&"
import script from "./newTree.vue?vue&type=script&lang=js&"
export * from "./newTree.vue?vue&type=script&lang=js&"
import style0 from "./newTree.vue?vue&type=style&index=0&id=57c3d735&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports